export const PartNer = [
  {
    id: "1",
    type: "Extra Ordinary ROI",
    description:
      "Our Channel Partners & Reseller Partnersare able to make millions by selling & Referring our solutions. With minimum operation cost, recession an inflation-free software market, the chances of earning and boosting your revenue by partnering are very high.",
  },
  {
    id: "2",
    type: "Fast-growing Ed Tech",
    description:
      "The market opportunity for Ed Tech Solutions is rising and is expected to reach 25 billion USD by 2025. The effective Ed Tech solution is being preferred by all kinds of academic institutions of all sizes to manage their activities in a effective manners.",
  },
  {
    id: "3",
    type: "360° Support ",
    description:
      "Our product specialist will train you properly about all the modules and our sales expert will train you in selling the product. We also provide the Digital Marketing Support on request by the Channel Partner.",
  },
  {
    id: "4",
    type: "Exclusive Benefits",
    description:
      "We provide exclusive incentives and benefits evaluating the sales performance of our channel partners at the end of the Year. Benefits include Gift Hampers, Tour Package, extra incentives and many more.",
  },
];
